/* =========================================================
   Hızlı bakış modalı — ürün kartındaki göz butonundan açılır.
   İçerik Section Rendering API ile çekilir:
     /products/<handle>?section_id=quick-view
   Fetch başarısızsa ürün sayfasına düz gidilir (JS'siz davranış).
   ========================================================= */
(function () {
  "use strict";

  var SECTION_ID = "quick-view";
  var modal = null;
  var content = null;
  var panel = null;
  var lastTrigger = null;
  var currentToken = 0;

  function els() {
    if (modal) return true;
    modal = document.querySelector("[data-quick-view]");
    if (!modal) return false;
    content = modal.querySelector("[data-quick-view-content]");
    panel = modal.querySelector("[data-quick-view-panel]");
    return true;
  }

  function open() {
    modal.hidden = false;
    /* hidden kalkmadan sınıf eklenirse geçiş oynamıyor: araya zorunlu bir
       reflow koyuluyor. requestAnimationFrame KULLANILMIYOR — sekme arka
       plandayken Chrome rAF'ı durduruyor ve modal görünmez kalıyordu. */
    void modal.offsetHeight;
    modal.classList.add("is-open");
    document.documentElement.classList.add("quick-view-open");
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove("is-open");
    document.documentElement.classList.remove("quick-view-open");
    modal.hidden = true;
    content.innerHTML = "";
    currentToken++;
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  function skeleton() {
    return '<div class="quick-view__loading" role="status">' +
      (window.theme && window.theme.strings && window.theme.strings.loading ? window.theme.strings.loading : "Yükleniyor…") +
      "</div>";
  }

  function load(url) {
    var token = ++currentToken;
    content.innerHTML = skeleton();
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    return fetch(url.split("#")[0] + sep + "section_id=" + encodeURIComponent(SECTION_ID))
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        /* Araya başka bir ürün tıklandıysa bu yanıtı yoksay */
        if (token !== currentToken) return;
        content.innerHTML = html;
        panel.scrollTop = 0;
        var focusable = panel.querySelector("[data-quick-add], .quick-view__more");
        if (focusable) focusable.focus({ preventScroll: true });
      });
  }

  /* ---------- Açma ---------- */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest ? e.target.closest("[data-quick-view-open]") : null;
    if (!trigger) return;
    if (!window.fetch || !els()) return;
    e.preventDefault();
    lastTrigger = trigger;
    open();
    load(trigger.getAttribute("data-product-url")).catch(function () {
      close();
      window.location.href = trigger.getAttribute("data-product-url");
    });
  });

  /* ---------- Kapatma ---------- */
  document.addEventListener("click", function (e) {
    if (!modal || modal.hidden) return;
    if (e.target.closest("[data-quick-view-close]")) { close(); return; }
    /* Sepete eklendi: çekmece açılacağı için modal kapanmalı.
       stopPropagation YOK — asıl ekleme işini global.js'teki [data-quick-add] yapıyor. */
    if (e.target.closest("[data-quick-add]") && modal.contains(e.target)) {
      setTimeout(close, 150);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !modal || modal.hidden) return;
    close();
  });

  /* ---------- Modal içi adet ---------- */
  document.addEventListener("click", function (e) {
    if (!modal || modal.hidden || !modal.contains(e.target)) return;
    var minus = e.target.closest("[data-qty-minus]");
    var plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;
    var scope = (minus || plus).closest("[data-qty-scope]");
    var input = scope && scope.querySelector("[data-qty]");
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    input.value = plus ? value + 1 : Math.max(1, value - 1);
  });

  /* ---------- Modal içi kardeş ürün geçişi ----------
     Sayfayı terk etmek yerine modalı yeni ürünle tazele. Yakalama fazında
     çalışır ki variant-siblings.js'in kendi yönlendirmesi devreye girmesin. */
  document.addEventListener("click", function (e) {
    if (!modal || modal.hidden || !modal.contains(e.target)) return;
    var link = e.target.closest ? e.target.closest("[data-sibling-link]") : null;
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    if (link.hasAttribute("aria-current")) return;
    load(link.getAttribute("href")).catch(function () {
      window.location.href = link.getAttribute("href");
    });
  }, true);
})();
